import { ReactNode } from 'react'
import { css, Theme } from '@emotion/react'
import { HelpIcon } from '@/components/icon/HelpIcon'

// フィールド行のコンテナ
const containerStyle = css`
  display: flex;
  flex-direction: column;
  &:not(:first-of-type) {
    margin-top: 8px;
  }
`

// ラベルと入力欄の横並びレイアウト
const contentStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
`

// ラベルスタイル
const labelStyle = (t: Theme, width: number) => css`
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.4rem;
  color: ${t.c.ec.black};
  display: block;
  width: ${width}px;
  flex-shrink: 0;
`

// 必須マーク
const requiredMark = (t: Theme) => css`
  color: ${t.c.bc.error};
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.4rem;
`

// エラー表示
const errorStyle = (labelWidth: number) => css`
  color: #ff0000;
  font-size: 1.2rem;
  margin-top: 4px;
  margin-left: ${labelWidth}px;
`

type Props = {
  label: string
  required?: boolean
  labelWidth?: number
  error?: string
  helpText?: string
  children: ReactNode
}

export const FormFieldRow = ({
  label,
  required = false,
  labelWidth = 147,
  error,
  helpText,
  children,
}: Props) => {
  return (
    <div css={containerStyle}>
      <div css={contentStyle}>
        <span css={(t) => labelStyle(t, labelWidth)}>
          {label}
          {required && <span css={requiredMark}>*</span>}
          {helpText && <HelpIcon text={helpText} size="small" />}
        </span>
        {children}
      </div>
      {error && <div css={errorStyle(labelWidth)}>{error}</div>}
    </div>
  )
}
